import * as React from 'react'
import { ReactElement } from 'react'
import FileForm, { FileFormType } from '../../components/Form/File/FileForm'
import { FileAction, FileMutationDto, IOverviewItemDto } from '../../config/fileConfig'
import { useParams } from 'react-router-dom'
import Loading from '../../components/Loading'
import useEntity from '../../hooks/useEntity'
import useAxios from '../../hooks/useAxios'
import { EntityParams } from '../../components/Form/Form'
import useUnits from '../../hooks/useUnits'
import { useDispatch, useSelector } from 'react-redux'
import { Store } from '../../reducers'
import { DataPromise } from '../../context/AxiosContext'
import { IFileListSettings } from '../../components/List/File/FileList'
import { ModulesConstants } from '../../components/Form/File/ModulePivotItem'
import { useSettings } from '../../hooks/useSettings'
import useModules from '../../hooks/module/useModules'
import { parseFileSettingsToParams } from './FileOverview'

export default function EditFile(): ReactElement {
    const axios = useAxios()
    const dispatch = useDispatch()

    const { id } = useParams<EntityParams>()
    const { activeUnits } = useUnits()
    const modules = useModules()
    const settings = useSettings()
    const [entity] = useEntity<FileMutationDto>((id: string) => ({ url: `/file/${id}/edit` }), id)
    const { settings: fileSettings } = useSelector<Store, DataPromise<IOverviewItemDto[], IFileListSettings>>(
        state => state.files.overview,
    )

    if (!entity.loaded) {
        return <Loading />
    }

    if (entity.data.modules && entity.data.modules.length > 0) {
        entity.data.modules.forEach(module =>
            ModulesConstants.get(module.type)?.onAfterChecked?.(entity.data, settings),
        )
    }

    modules?.modules
        ?.filter(module => !module.fileModule)
        .forEach(module => ModulesConstants.get(module.type)?.onAfterChecked?.(entity.data, settings))

    return (
        <FileForm
            id={id}
            formType={FileFormType.Edit}
            formikProps={{
                initialValues: {
                    unit: activeUnits.length === 1 ? activeUnits[0].key : undefined,
                    ...entity.data,
                },
            }}
            onSubmit={(file: FileMutationDto) =>
                axios.put<string>(`/file/${id}`, file).then(response => {
                    if (
                        entity.data.name !== file.name ||
                        entity.data.ownerId !== file.ownerId ||
                        entity.data.status !== file.status
                    ) {
                        dispatch({
                            type: FileAction.GetOverview,
                            payload: axios.get('/file', { params: parseFileSettingsToParams(fileSettings) }),
                        })
                    }
                    return response
                })
            }
        />
    )
}
